import { getBasicInfo } from "../../../sessionStorage";

export default function AnalysisData() {
    const basicInfoObj = getBasicInfo();
    const birthdate = basicInfoObj && basicInfoObj.birthdate;
    const gender = basicInfoObj && basicInfoObj.gender;

    const AnnalysisInfo = {
        birthdate: basicInfoObj ? birthdate : '',
        gender: basicInfoObj ? gender : '',
        spouseBirthdate: '',
        maritalStatus: '',
        numberOfChildren: '',
        childWillAttendCollege: '',
        annualIncome: '',
        percentOfIncomeFamily: 80,
        mortgageBalance: '',
        monthlyMortgagePayment: '',
        totalDebt: '',
        normalMonthlyExpenses: '',
        totalSavings: '',
        totalInvestments: '',
        existingLifeInsurance: '',
        spouseAnnualIncome: '',
        children: [],
    };
    return AnnalysisInfo;
};


// WEBPACK FOOTER //
// ./src/components/Helpers/Constants/AnalysisData.js